import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { open, close } from '../../../helpers/index';

const Facet = ({ facet, selected, onFilterChange, onListDisplay }) => {
  const breakpoint = window.matchMedia('(max-width: 1279px)');
  const { keyword, name } = facet;
  const [display, setDisplay] = useState(!breakpoint.matches);
  const filterList = useRef(null);

  const handleSelect = value => {
    const selectedClone = selected ? [...selected] : [];

    if (selectedClone?.includes(value)) {
      selectedClone?.splice(selectedClone?.indexOf(value), 1);
    } else {
      selectedClone?.push(value);
    }

    const facetItems = {
      name: keyword,
      options: selectedClone
    };

    onFilterChange(facetItems);
  };

  useEffect(() => {
    const listener = () => {
      if (breakpoint.matches) {
        setDisplay(false);
      } else {
        setDisplay(true);
      }
    };

    breakpoint.addListener(listener);
    return () => breakpoint.removeListener(listener);
  }, []);

  useEffect(() => {
    if (display) {
      filterList.current.style = null;
      open({ element: filterList.current });
    } else {
      close({
        element: filterList.current
      });
    }
  }, [display, facet]);

  return (
    <div className="facet">
      <button
        className={`facet__title-btn${
          display ? ' facet__title-btn--open' : ''
        }`}
        onChange={() => onListDisplay()}
        onClick={() => setDisplay(!display)}
      >
        {name}
        <div className="facet__title-icon">
          {display ? (
            <svg viewBox="0 0 14 2">
              <use xlinkHref="#minus" />
            </svg>
          ) : (
            <svg viewBox="0 0 14 14">
              <use xlinkHref="#plus" />
            </svg>
          )}
        </div>
      </button>
      <div className="facet__list" data-list-from={keyword} ref={filterList}>
        <div className="facet__list-inner">
          {facet.options.map((option, i) => (
            <div key={i} className="facet__option">
              <label className="facet__input" htmlFor={`${option.name}-${i}`}>
                <input
                  type="checkbox"
                  name={`${option.name}-${i}`}
                  id={`${option.name}-${i}`}
                  checked={
                    option.selected
                      ? option.selected
                      : selected?.includes(option.value) || ''
                  }
                  onChange={() => handleSelect(option.name)}
                />
                <span className="checkmark"></span>
                <span className="label">{option.name}</span>
              </label>
              <p className="facet__count">{option.matches}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Facet.propTypes = {
  facet: PropTypes.object,
  selected: PropTypes.array || PropTypes.string,
  onFilterChange: PropTypes.func.isRequired,
  onListDisplay: PropTypes.func.isRequired
};

export default Facet;
